import React from "react";
import "./CareersPage.css";

const CareersPage = () => {
  return (
    <>
      <div className="careersSection">
        <h2>Join the Health Revolution at SwasthMitra</h2>
        <div className="careersContent">
          <p>
            Are you passionate about transforming healthcare in India?
            <br />
            Do you believe that <strong>everyone deserves access to trustworthy, affordable medical care</strong>?
          </p>
          <p>
            If yes, you're in the right place.
          </p>
          <p>
            At <strong>SwasthMitra</strong>, we're building more than just an online pharmacy — we're building a <strong>movement</strong>. And we're looking for people like you to join us on this journey.
          </p>

          <hr />

          <h3>🚀 Current Openings</h3>

          <div className="jobOpening">
            <h4>1. Affiliate Partners <span className="jobType">(Work From Anywhere)</span></h4>
            <p>
              Love digital marketing? Got a network that trusts your recommendations?
              <br />
              Join our <strong>Affiliate Program</strong> and earn by promoting SwasthMitra's genuine, affordable medicines. No investment required — just your influence, and our support.
            </p>
            <div className="jobPerks">
              <p><strong>Perks</strong>: High commission rates, marketing tools, regular payouts, dedicated support team.</p>
            </div>
          </div>

          <div className="jobOpening">
            <h4>2. Relationship Manager <span className="jobType">(Full-Time | Remote/On-site Hybrid)</span></h4>
            <p>
              We're looking for skilled Relationship Managers to handle partnerships with clinics, doctors, pharmacies, and corporate clients.
            </p>
            <div className="jobDetails">
              <p><strong>Responsibilities</strong>:</p>
              <ul>
                <li>Manage B2B relationships</li>
                <li>Drive sales through professional partnerships</li>
                <li>Ensure client satisfaction and retention</li>
              </ul>
              <p><strong>What We Need</strong>:</p>
              <ul>
                <li>Strong communication skills</li>
                <li>Experience in sales or healthcare preferred</li>
                <li>Self-driven, target-oriented personality</li>
              </ul>
            </div>
          </div>

          <div className="jobOpening">
            <h4>3. Relationship Executive <span className="jobType">(Full-Time | Entry Level)</span></h4>
            <p>
              Perfect for freshers or those looking to build a career in the healthcare space.
            </p>
            <div className="jobDetails">
              <p><strong>Responsibilities</strong>:</p>
              <ul>
                <li>Assist Relationship Managers</li>
                <li>Manage queries, client onboarding, follow-ups</li>
                <li>Coordinate with internal teams</li>
              </ul>
              <p><strong>What We Need</strong>:</p>
              <ul>
                <li>Good communication & basic tech knowledge</li>
                <li>Energetic, people-first approach</li>
                <li>Willingness to learn and grow</li>
              </ul>
            </div>
          </div>

          <h3>🌟 Why Join SwasthMitra?</h3>

          <div className="benefits">
            <p>✅ <strong>Mission-Driven Work</strong> – Help make healthcare accessible to millions</p>
            <p>✅ <strong>Flexible Work Models</strong> – Remote and hybrid options available</p>
            <p>✅ <strong>Growth Opportunities</strong> – We grow together — training, upskilling, and promotions</p>
            <p>✅ <strong>Young, Passionate Team</strong> – A team that's driven by purpose, not politics</p>
            <p>✅ <strong>Rewards & Recognition</strong> – We notice effort and celebrate success</p>
          </div>

          <hr />

          <h3>💼 Ready to Make a Difference?</h3>
          <p>
            If you're ready to grow with a company that cares — not just about customers, but also about its people — we'd love to hear from you.
          </p>
          <p>
            📩 <strong>Send your resume to <a href="mailto:info@swasthmitra.com">info@swasthmitra.com</a></strong>
            <br />
            Or apply via the form below.
          </p>
          <p>
            Let's build the future of healthcare, together.
          </p>
        </div>
      </div>
    </>
  );
};

export default CareersPage;